import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-341b006a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo-box column-center" }
const _hoisted_2 = { class: "top animate__animated animate__fadeInDown wow" }
const _hoisted_3 = { class: "toplogo" }
const _hoisted_4 = { alt: "" }
const _hoisted_5 = { class: "center row-center" }
const _hoisted_6 = {
  "data-wow-delay": "1s",
  class: "animate__animated animate__fadeInDown wow"
}
const _hoisted_7 = {
  "data-wow-delay": "0.5s",
  class: "centerlogo animate__animated animate__fadeInUp wow"
}
const _hoisted_8 = { alt: "" }
const _hoisted_9 = {
  "data-wow-delay": "1.5s",
  class: "animate__animated animate__fadeInDown wow"
}
const _hoisted_10 = {
  "data-wow-delay": "2s",
  class: "bottom animate__animated animate__fadeInUp wow"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Rekey", -1))

import WOW from 'wowjs'
import { onMounted } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'LogoView',
  setup(__props) {

onMounted(() => {
  new WOW.WOW(
    { live: false }
  ).init()
})

return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
          [_directive_lazy, require('@/assets/logotext.png')]
        ])
      ]),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('logotitle')), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('logolefttext')), 1),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
          [_directive_lazy, require('@/assets/logocenter.png')]
        ])
      ]),
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('logorighttext')), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('logobottomtext')), 1)
    ])
  ]))
}
}

})